import httpClient from "Api/httpClient";

const END_POINT = "/oauth/providers";

const getOauthProviders = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getOauthProvider = (provider_id) => {
    if (!provider_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + provider_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printOauthProvider = (provider_id) => {
    if (!provider_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?provider_id=" + provider_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createOauthProviders = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateOauthProviders = (payload, provider_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + provider_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteOauthProviders = (provider_id) => {
    const DELETE_END_POINT = END_POINT + "/" + provider_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getOauthProviders, getOauthProvider, printOauthProvider, createOauthProviders, updateOauthProviders, deleteOauthProviders };
